import ReportsNavigationOptions from './ReportsMenuPanel'
export default ReportsNavigationOptions
